/** Public docs URL prefixes (single source of truth). */
export const DOCS_BASE_PATH = "/docs";
export const DOCS_HELP_CENTER_PATH = "/docs";
export const DOCS_KNOWLEDGE_BASE_PATH = "/docs/knowledge-base";
export const DOCS_API_REFERENCE_PATH = "/docs/api-reference";

export const LEGACY_DEVELOPERS_API_PATH = "/developers/api";

export function docsHelpCenterLink(slug: string) {
	return {
		to: "/docs/$slug" as const,
		params: { slug },
	};
}

export function docsKnowledgeBaseLink(slug: string) {
	return {
		to: "/docs/knowledge-base/$slug" as const,
		params: { slug },
	};
}

export type DocsCenterRouteLink =
	| ReturnType<typeof docsHelpCenterLink>
	| ReturnType<typeof docsKnowledgeBaseLink>;

export function docsApiReferenceLink(slug: string) {
	return {
		to: "/docs/api-reference/$" as const,
		params: { _splat: slug },
	};
}

export function isDocsHelpCenterPath(pathname: string): boolean {
	return (
		pathname === DOCS_BASE_PATH ||
		(pathname.startsWith(`${DOCS_BASE_PATH}/`) &&
			!pathname.startsWith(DOCS_API_REFERENCE_PATH) &&
			!pathname.startsWith(DOCS_KNOWLEDGE_BASE_PATH))
	);
}

export function isDocsApiReferencePath(pathname: string): boolean {
	return (
		pathname === DOCS_API_REFERENCE_PATH ||
		pathname.startsWith(`${DOCS_API_REFERENCE_PATH}/`)
	);
}

export function isDocsKnowledgeBasePath(pathname: string): boolean {
	return (
		pathname === DOCS_KNOWLEDGE_BASE_PATH ||
		pathname.startsWith(`${DOCS_KNOWLEDGE_BASE_PATH}/`)
	);
}

export function legacyDevelopersApiRedirectTarget(splat?: string) {
	if (!splat) {
		return { to: "/docs/api-reference" as const };
	}
	return docsApiReferenceLink(splat.replace(/^\/+|\/+$/g, ""));
}
